import { BrandKey, TagProviderName } from '../../__generated__/queries-web';

export const TAGS_SECTION_ID_SELECTOR = 'tags-enhancement';
export const TAGS_AUTOCOMPLETE_LIST_HEADER = 'Suggestions';

export const BRANDKEYS_PROVIDERS_LIST: Record<BrandKey, TagProviderName[]> = {
  [BrandKey.BEA]: [TagProviderName.Tag, TagProviderName.Person],
  [BrandKey.BIN]: [TagProviderName.Tag, TagProviderName.Person],
  [BrandKey.BONE]: [TagProviderName.Tag],
  [BrandKey.BRGTS]: [TagProviderName.Tag],
  [BrandKey.BROMM]: [TagProviderName.Tag],
  [BrandKey.CAC]: [TagProviderName.Tag, TagProviderName.Person],
  [BrandKey.CAM]: [TagProviderName.Tag, TagProviderName.Person],
  [BrandKey.CAP]: [
    TagProviderName.Tag,
    TagProviderName.Person,
    TagProviderName.Company,
  ],
  [BrandKey.CTR]: [TagProviderName.Tag],
  [BrandKey.DEGTS]: [TagProviderName.Tag],
  [BrandKey.DESAS]: [TagProviderName.Tag],
  [BrandKey.DEOMM]: [TagProviderName.Tag],
  [BrandKey.ESGTS]: [TagProviderName.Tag],
  [BrandKey.ESOMM]: [TagProviderName.Tag],
  [BrandKey.FAC]: [TagProviderName.Tag, TagProviderName.Person],
  [BrandKey.SHGFAC]: [TagProviderName.Tag, TagProviderName.Person],
  [BrandKey.FRGSD]: [TagProviderName.Tag, TagProviderName.Person],
  [BrandKey.FRGSG]: [TagProviderName.Tag, TagProviderName.Person],
  [BrandKey.FRGSL]: [TagProviderName.Tag, TagProviderName.Person],
  [BrandKey.FRGSS]: [TagProviderName.Tag, TagProviderName.Person],
  [BrandKey.FRGSV]: [TagProviderName.Tag, TagProviderName.Person],
  [BrandKey.FROMM]: [TagProviderName.Tag, TagProviderName.Person],
  [BrandKey.GAL]: [TagProviderName.Tag, TagProviderName.Person],
  [BrandKey.GEO]: [
    TagProviderName.Tag,
    TagProviderName.Destination,
    TagProviderName.Person,
  ],
  [BrandKey.HBR]: [TagProviderName.Tag],
  [BrandKey.HBZ]: [TagProviderName.Tag, TagProviderName.Person],
  [BrandKey.ITGTS]: [TagProviderName.Tag],
  [BrandKey.ITOMM]: [TagProviderName.Tag],
  [BrandKey.NEO]: [TagProviderName.Tag, TagProviderName.Person],
  [BrandKey.SIM]: [TagProviderName.Tag],
  [BrandKey.TEL]: [
    TagProviderName.Tag,
    TagProviderName.Person,
    TagProviderName.TvProgram,
    TagProviderName.TvCollection,
  ],
  [BrandKey.TLA]: [
    TagProviderName.Tag,
    TagProviderName.Person,
    TagProviderName.TvProgram,
    TagProviderName.TvCollection,
  ],
  [BrandKey.TLS]: [
    TagProviderName.Tag,
    TagProviderName.Person,
    TagProviderName.TvProgram,
    TagProviderName.TvCollection,
  ],
  [BrandKey.TGC]: [
    TagProviderName.Tag,
    TagProviderName.Person,
    TagProviderName.TvProgram,
    TagProviderName.TvCollection,
  ],
  [BrandKey.UKGTS]: [TagProviderName.Tag],
  [BrandKey.UKOMM]: [TagProviderName.Tag],
  [BrandKey.UKSAS]: [TagProviderName.Tag],
  [BrandKey.VDF]: [TagProviderName.Tag],
  [BrandKey.VOI]: [TagProviderName.Tag, TagProviderName.Person],
  [BrandKey.TESTBRAND]: [
    TagProviderName.Tag,
    TagProviderName.Person,
    TagProviderName.TvProgram,
    TagProviderName.TvCollection,
    TagProviderName.TvBy,
  ],
};
